import React from "react";
import Experience from "../Items/Experience";

const experiencesData = [
  {
    id: 1,
    year: "2023 - Present",
    degree: "Manager",
    company: "TECHUNIQUEIIT",
    companyUrl: "https://www.techuniqueiit.com/",
    content:
      "Promoted to Manager in 2023. Leading development teams, managing client deliverables, technical architecture, code reviews, and end-to-end full-stack software solutions.",
  },
  {
    id: 2,
    year: "Oct 2022 - 2023",
    degree: "Fullstack Developer",
    company: "TECHUNIQUEIIT",
    companyUrl: "https://www.techuniqueiit.com/",
    content:
      "Began full-stack software development in 2022. Architected and built dynamic web applications, LMS portals, and component-based solutions using React.js, Node.js, Express, MongoDB, RESTful Web APIs, TailwindCSS, and SQL databases.",
  },
  {
    id: 3,
    year: "2021 - Oct 2022",
    degree: "Frontend Developer",
    company: "Freelance Web Developer",
    companyUrl: "",
    content:
      "Delivered responsive websites and client web applications utilizing HTML5, CSS3, JavaScript, Bootstrap, and WordPress CMS customization.",
  },
  {
    id: 4,
    year: "2019 - 2021",
    degree: "Graphics Design",
    company: "Freelance Designer",
    companyUrl: "",
    content:
      "Started creative journey in 2019 delivering branding, graphic assets, social media designs, and modern UI visual designs for diverse global clients.",
  },
];

function Experiences() {
  const currentYear = new Date().getFullYear();
  const totalExperience = currentYear - 2019;
  const itExperience = currentYear - 2021;

  return (
    <>
      <p
        className="mb-4"
        style={{ fontSize: "15px", lineHeight: "1.8", color: "#555" }}
      >
        I bring over{" "}
        <strong style={{ color: "#222" }}>{totalExperience}+ years</strong> of
        total industry experience since 2019, including{" "}
        <strong style={{ color: "#222" }}>{itExperience}+ years</strong> of
        dedicated professional experience in the IT sector. Started with creative
        design and freelancing, progressed into full-stack software engineering,
        and was promoted to Manager in 2023 at{" "}
        <strong style={{ color: "#222" }}>TECHUNIQUEIIT</strong> where I
        currently manage and deliver high-impact web solutions.
      </p>
      <div className="timeline">
        {experiencesData.map((experience) => (
          <Experience experience={experience} key={experience.id} />
        ))}
        <span className="timeline-line"></span>
      </div>
    </>
  );
}

export default Experiences;
